const mapPaletteArrayToObject = (arr) => {
  const resultObject = {};

  arr.forEach((color, i) => {
    if (i === 0) {
      resultObject[50] = color;
    } else {
      resultObject[i * 100] = color;
    }
  });
  return resultObject;
};

export default mapPaletteArrayToObject;
